<template>
    <div class="row padding-bottom-1 padding-top-1 question" :class="cableSelection && 'cable-wrapper'">
        <slot name="title">
            <div class="title" :class="cableSelection && 'cable-title'">{{ title }}</div>
        </slot>
        <slot name="subtitle">
            <div class="subtitle">{{ subtitle }}</div>
        </slot>
        <div class="padding-top flex flex-wrap option-container">
            <div
            v-for="(option) in options"
            :key="option"
            :class="`col xs-12 sm-12 md-4 flex flex-around offer ${option === selectedOption ? 'active' : ''}`"
            :value="option"
            @click="onOptionClick(option)"
            >
                {{ option }}
            </div>
        </div>
    </div>
</template>

<script>
    export default {

        props: {
            title: {
                type: String,
                required: false,
            },
            subtitle: {
                type: String,
                required: false,
            },
            options: {
                type: Array,
                required: true,
            },
            selectedOption: {
                type: String,
                required: true
            },
            cableSelection: {
                type: Boolean,
                required: false
            },
        },

        data() {
                return {
                }
        },

        methods: {
            onOptionClick(option) {
                this.$emit("onOptionClick", option);
            },
        },
    }
</script>

<style scoped>

    .flex {
        display: flex;
    }

    .flex-center {
        align-items: center;
        justify-content: center;
    }

    .flex-around {
        align-items: center;
        justify-content: space-around;
    }

    .question {
        flex-direction: column;
    }

    .cable-wrapper {
        max-width: 90%;
        margin: 0 auto;
        margin-bottom: 0;
        margin-top: 30px;
        padding-bottom: 0 !important;
    }

    .title {
        font-size: 34px;
        font-weight: 500;
        color: #2E3438;
        line-height: 34px;
    }

    .cable-title {
        font-weight: 500;
        font-size: 22px;
        line-height: 20px;
        color: #2e3438;
    }

    .subtitle {
        font-size: 24px;
        color: #474F54;
        margin: 30px 0px;
    }

    .option-container {
        width: 100%;
    }

    .offer {
        cursor: pointer;
        font-size: 18px;
        font-weight: bold;
        text-align: center;
        line-height: 20px;
        background: #FFFFFF;
        border: 3px solid #FFFFFF;
        box-sizing: border-box;
        box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.1);
        border-radius: 6px;
        padding: 10px 9px;
        min-height: 65px;
        max-height: 65px;
        margin-bottom: 25px;
        margin-left: 10px;
        margin-right: 10px;
    }

    .active {
        border: 3px solid #1A74DB;
    }

    @media screen and (max-width: 735px){
        .option-container {
            width: 95%;
        }
    }

</style>
